<template>
  <Teleport to="body">
    <div v-if="isVisible" class="popup-overlay" @click.self="closePopup">
      <div class="popup-container">
        <button class="close-btn" @click="closePopup" aria-label="닫기">
          &times;
        </button>

        <div class="popup-content">
          <h2 class="sub-title">바로주문 고객님만을 위한 추가 혜택!</h2>

          <div class="main-benefit">
            <span class="text" v-html="msg"></span>
          </div>

          <button class="action-btn" @click="closePopup">
            지금 주문하고 혜택받기
          </button>
        </div>

        <div class="popup-footer">
          <label class="checkbox-label">
            <input
                type="checkbox"
                v-model="doNotShowToday"
            />
            <span class="checkmark"></span>
            오늘 하루 보지 않기
          </label>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
const route = useRoute();

const isVisible = ref(false);
const doNotShowToday = ref(false);
const STORAGE_KEY = 'hide_meat_benefit_popup_date'; // 고유한 키값 사용

// 오늘 날짜 문자열 반환 (YYYY-MM-DD)
const getTodayString = () => {
  const d = new Date();
  const year = d.getFullYear();
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
};

onMounted(() => {
  const storedDate = localStorage.getItem(STORAGE_KEY);
  const today = getTodayString();

  // 저장된 날짜가 없거나, 오늘 날짜와 다르면 팝업 노출
  if (storedDate !== today) {

    // path 확인한다
    if(route.path=='/menu' || route.path=='/smenu')
      isVisible.value = true
  }
});

const props = defineProps({
  msg: {
    type: String,
    default: ''
  },
})


const closePopup = () => {
  if (doNotShowToday.value) {
    // 체크 시 오늘 날짜를 저장 (내일이 되면 날짜가 달라지므로 다시 뜸)
    localStorage.setItem(STORAGE_KEY, getTodayString());
  }
  isVisible.value = false;
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700;900&display=swap');

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* 배경을 조금 더 어둡게 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  font-family: 'Noto Sans KR', sans-serif;
  backdrop-filter: blur(2px); /* 배경 블러 효과 */
}

.popup-container {
  background: white;
  width: 400px; /* 혜택 팝업은 보통 작고 임팩트 있게 */
  max-width: 90%;
  border-radius: 24px;
  position: relative;
  box-shadow: 0 20px 40px rgba(0,0,0,0.3);
  overflow: hidden;
  text-align: center;
  animation: popIn 0.3s ease-out;
}

@keyframes popIn {
  0% { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  line-height: 1;
  z-index: 10;
}
.close-btn:hover { color: #333; }

.popup-content {
  padding: 40px 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.badge {
  background-color: #FF5722;
  color: white;
  font-size: 12px;
  font-weight: 900;
  padding: 4px 10px;
  border-radius: 20px;
  margin-bottom: 10px;
  letter-spacing: 1px;
}

.sub-title {
  font-size: 18px;
  color: #555;
  font-weight: 700;
  margin: 0 0 15px 0;
}

.main-benefit {
  background-color: #FFF3E0; /* 연한 주황 배경 */
  width: 100%;
  padding: 20px 0;
  border-radius: 16px;
  margin-bottom: 20px;
  border: 2px dashed #FFCC80;
}

.main-benefit .icon {
  font-size: 40px;
  display: block;
  margin-bottom: 5px;
}

.main-benefit .text {
  font-size: 28px;
  font-weight: 900;
  color: #333;
  line-height: 1.2;
}

.main-benefit .highlight {
  color: #D84315; /* 진한 주황/빨강 */
  font-size: 32px;
}

.description {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 25px;
}

.action-btn {
  background: linear-gradient(135deg, #FF7043 0%, #D84315 100%);
  color: white;
  border: none;
  width: 100%;
  padding: 15px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(216, 67, 21, 0.3);
  transition: transform 0.1s;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(216, 67, 21, 0.4);
}

.action-btn:active {
  transform: translateY(0);
}

/* 하단 체크박스 영역 */
.popup-footer {
  background-color: #f9f9f9;
  padding: 12px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #eee;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  color: #888;
}

.checkbox-label input {
  margin-right: 6px;
  accent-color: #555;
  cursor: pointer;
}
</style>